import React, { Component } from 'react';
import { Navbar, Button } from 'react-bootstrap';
import './App.css';

class Nav extends Component {

  render() {
    var isAuthenticated = this.props.is_auth;
    var user = this.props.user;
    //var client = this.props.client;

    var text,className,onClick;
    if (isAuthenticated){
      className="btn-margin-logout";
      text = "Log Out";
      onClick = this.props.logout;
    }else{
      className="btn-margin-login";
      text = "Log In";
      onClick = this.props.login;
    }

    return (
      <div>
        <Navbar >
          <Navbar.Header className="navbar-header">
            <Navbar.Brand className="navbar-brand">
            {
              {isAuthenticated} && (
                <h5> Welcome {user}!</h5>
                )
            }
            </Navbar.Brand>
            {
                <Button bsStyle="primary" className={className}
                  onClick={onClick}>
                  {text}
                </Button>

            }
          </Navbar.Header>
        </Navbar>
      </div>
    );
  }
}

export default Nav;
